module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "explainRule"
    }
  }, [_c('h1', [_vm._v("补交阶梯差价计算说明")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('el-table', {
    ref: "filterTable",
    staticStyle: {
      "width": "1200px",
      "margin": "auto"
    },
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "grade",
      "label": "年阶梯分档"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "range",
      "label": "电量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "电价（元 / 度）"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.type === 0 ? 'success' : scope.row.type === 1 ? 'warning' : 'danger',
            "disable-transitions": ""
          }
        }, [_vm._v("￥ " + _vm._s(scope.row.price))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('el-alert', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "info",
      "description": "电表设置电价说明：本年阶梯电表设置电价为无阶梯0.52元/度，电表本身计量一直按照0.52元/度计算，如果用量超出阶梯范围，则进行补交差价，补交差价在充值时自动扣除。",
      "show-icon": "",
      "closable": false
    }
  }), _vm._v(" "), _c('el-collapse', {
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "计算公式：",
      "name": "1"
    }
  }, [_c('p', [_vm._v("（1）总电量＝第一档电量+第二档电量+第三档电量")]), _vm._v(" "), _c('p', [_vm._v("（2）总电费＝第一档电费+第二档电费+第三档电费")]), _vm._v(" "), _c('p', [_vm._v("（3）第一档电费 = 第一档标准以内的电量×原居民电价")]), _vm._v(" "), _c('p', [_vm._v("（4）第二档电费 = 超出第一档标准并且在第二档标准以内的电量×（原居民电价+0.05元/度）")]), _vm._v(" "), _c('p', [_vm._v("（5）第三档电费 = 超出第二档标准的电量×（原居民电价+0.3元/度）")]), _vm._v(" "), _c('small', [_vm._v("注：第二档和第三档电费只有当居民实际用电量分别超出该档次标准才要计收")])]), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "计算示例：",
      "name": "2"
    }
  }, [_c('p', [_vm._v("①处于2阶梯电量（第一次补交阶梯差价）：")]), _vm._v(" "), _c('p', [_vm._v("充值前本年用量 = 2190度")]), _vm._v(" "), _c('p', [_vm._v("超出标准用量 = 2190度-2160度=30度")]), _vm._v(" "), _c('p', [_vm._v("阶梯差价单价 = 0.05元/度")]), _vm._v(" "), _c('p', [_vm._v("补交阶梯差价 = 30度*0.05元/度=1.5元")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("②处于2阶梯电量（第二次补交阶梯差价）")]), _vm._v(" "), _c('p', [_vm._v("充值前本年用量 = 2580度")]), _vm._v(" "), _c('p', [_vm._v("超出标准用量 = 2580度-2190度 = 390度")]), _vm._v(" "), _c('p', [_vm._v("阶梯差价单价 = 0.05元/度")]), _vm._v(" "), _c('p', [_vm._v("补交阶梯差价 = 390度*0.05元/度 =19.5元")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("③处于3阶梯电量（第三次补交阶梯差价）")]), _vm._v(" "), _c('p', [_vm._v("充值前本年用量 = 3400度")]), _vm._v(" "), _c('p', [_vm._v("超出2阶梯标准用量 = （3400度-3360度）=40度")]), _vm._v(" "), _c('p', [_vm._v("超出1阶梯标准用量 = （3360度-2580度）=780度")]), _vm._v(" "), _c('p', [_vm._v("补交阶梯差价 = 40度*0.30元/度 +780度*0.05元/度 = 51元")])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-1bd54f17"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/explainRule.vue
// module id = 518
// module chunks = 1